import { FileText, Globe } from 'lucide-react';
import { useUserProfile } from '../../context/UserProfileContext';
import { useOrgSettings } from '../../hooks/useOrgSettings';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';
import { IS_FIREBASE_CONFIGURED } from '../../config/firebase';

const isDevMode = !IS_FIREBASE_CONFIGURED;

export function CustomerFacingHubPage() {
  const { adminOrg } = useUserProfile();
  const { org } = useOrgSettings(adminOrg?.orgId ?? '');
  const orgData = org as unknown as Record<string, unknown> | null;

  const onlineLeadCaptureEnabled = isDevMode || ((orgData?.featureOnlineLeadCapture ?? false) as boolean);
  const clientPortalEnabled = isDevMode || (orgData?.featureClientPortal !== false);

  const rows: SettingsRowDef[] = [
    {
      id: 'booking-form',
      label: 'Booking Form',
      desc: 'Lead intake form, URL slug, welcome message, and discovery sources.',
      icon: Globe,
      path: '/admin/customer-facing/booking-form',
      isVisible: onlineLeadCaptureEnabled,
    },
    {
      id: 'online-quotes',
      label: 'Online & PDF Quotes',
      desc: 'Customer quote portal and PDF quote generation.',
      icon: FileText,
      path: '/admin/customer-facing/online-quotes',
      isVisible: clientPortalEnabled,
    },
  ];

  return (
    <HubPageLayout
      title="Customer-Facing"
      subtitle="Booking form and online quote portal."
      rows={rows}
    />
  );
}
